import { useEffect, useState } from 'react';

import { useCurrentDate } from '#cutils/context/TimeContext';
import { formatTimestamp } from '#utils/time/formatTimestamp';
import { formatTimestampDateTime } from '#utils/time/formatTimestampDateTime';

type Props = {
	className?: string;
	publicationDate?: string | null;
	firstPublicationDate?: string | null;
	formatAbsolute?: boolean;
};

export function PublicationDate({ className, publicationDate, firstPublicationDate, formatAbsolute = false }: Props) {
	const currentDate = useCurrentDate();
	const [formattedPublicationDate, setFormattedPublicationDate] = useState(() =>
		publicationDate ? formatTimestamp(publicationDate, currentDate, { isAbsolute: formatAbsolute }) : null
	);

	// update date string when the component is mounted on the client, because the client might be in a different time zone
	useEffect(() => {
		// eslint-disable-next-line react-you-might-not-need-an-effect/no-derived-state, react-hooks/set-state-in-effect, @eslint-react/hooks-extra/no-direct-set-state-in-use-effect
		setFormattedPublicationDate(publicationDate ? formatTimestamp(publicationDate, currentDate, { isAbsolute: formatAbsolute }) : null);
	}, [currentDate, formatAbsolute, publicationDate]);

	if (!publicationDate) {
		return null;
	}
	const dateTimePublicationDate = formatTimestampDateTime(publicationDate);
	const formattedAbsolutePublicationDate = formatTimestamp(publicationDate, currentDate, { isAbsolute: true });
	const formattedFirstPublicationDate = firstPublicationDate ? formatTimestamp(firstPublicationDate, currentDate) : null;
	return (
		//  On request of Audience Analytics team, we have added static data-first-publication-date to S.PublicationDate, Info: Please consult Audience Analytics team before making any change.
		<time
			className={`aipd-gtm ${className ? className : ''}`}
			dateTime={dateTimePublicationDate || undefined}
			title={formattedAbsolutePublicationDate || undefined}
			data-first-publication-date={formattedFirstPublicationDate ?? undefined}
			suppressHydrationWarning={true}
		>
			{formattedPublicationDate}
		</time>
	);
}
